(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('AssignFieldOfficerToDepartmentDialogController', AssignFieldOfficerToDepartmentDialogController);

    AssignFieldOfficerToDepartmentDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'AssignFieldOfficerToDepartment'];

    function AssignFieldOfficerToDepartmentDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, AssignFieldOfficerToDepartment) {
        var vm = this;

        vm.assignFieldOfficerToDepartment = entity;
        vm.clear = clear;
        vm.save = save;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.assignFieldOfficerToDepartment.id !== null) {
                AssignFieldOfficerToDepartment.update(vm.assignFieldOfficerToDepartment, onSaveSuccess, onSaveError);
            } else {
                AssignFieldOfficerToDepartment.save(vm.assignFieldOfficerToDepartment, onSaveSuccess, onSaveError);
            }
        }
        function onSaveSuccess (result) {
            $scope.$emit('investhryApp:assignFieldOfficerToDepartmentUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();
